import { Outlet } from "react-router-dom";

export default function MainHostRegistry() {

    return(
        <Outlet />
    )
}